import { combineReducers, createStore, applyMiddleware } from "redux";
import { thunk } from "redux-thunk"; // Import Redux Thunk middleware
import userInfoReducer from "./reducer";

const rootReducer = combineReducers({
    userInfoReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
